/* YELASAI — Warenkorb-Spruch fuer die Premium-Produktseiten.
 *
 * Auf den alten Seiten steckte diese Logik in sections/ys-product.liquid.
 * Die Premium-Vorlagen laden diese Section nicht mehr, darum lag der Spruch
 * seit dem Go-live brach. Hier steht er eigenstaendig, damit er nicht wieder
 * an einer Vorlage haengt.
 *
 * Erwartet window.YSP_ADD = {openers:[…], benefits:[…], title:'…'}.
 * Faengt jedes Formular ab, das auf /cart/add zeigt.
 */
(function () {
  var A = window.YSP_ADD || {};
  var letzter = -1;

  function waehle(liste) {                       // nie zweimal denselben Opener
    if (!liste || !liste.length) return '';
    if (liste.length === 1) return liste[0];
    var i;
    do { i = Math.floor(Math.random() * liste.length); } while (i === letzter);
    letzter = i;
    return liste[i];
  }

  function irgendein(liste) {
    return (liste && liste.length) ? liste[Math.floor(Math.random() * liste.length)] : '';
  }

  function beacon(spruch, ereignis) {
    try {
      navigator.sendBeacon('https://yelasai.ai/spruch_beacon.php',
        new Blob([JSON.stringify({ s: spruch || '(ohne)', e: ereignis })],
                 { type: 'text/plain' }));
    } catch (e) { /* Messung darf den Kauf nie stoeren */ }
  }

  function warenkorbZahl() {
    try {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble span,[data-cart-count],.cart-count')
            .forEach(function (n) { n.textContent = c.item_count; });
        }).catch(function () {});
    } catch (e) {}
  }

  function zeige(name) {
    var alt = document.getElementById('ys-add-ok');
    if (alt) alt.remove();

    // Produktbezogener Spruch nur fuer das Hauptprodukt der Seite.
    // Bei Empfehlungen nennen wir das hinzugefuegte Produkt beim Namen.
    var eigen = !name || name === A.title;
    var spruch = eigen ? irgendein(A.benefits) : (name + ' ist in Ihrem Warenkorb.');
    var kopf = waehle(A.openers) || 'Im Warenkorb';

    var p = document.createElement('div');
    p.id = 'ys-add-ok';
    p.setAttribute('role', 'status');
    p.setAttribute('aria-live', 'polite');
    p.style.cssText = 'position:fixed;top:18px;left:50%;transform:translateX(-50%);' +
      'z-index:2147481000;background:#4A0D66;color:#F6F1E9;border-radius:14px;' +
      'padding:16px 20px;box-shadow:0 10px 34px rgba(0,0,0,.32);display:flex;' +
      'align-items:center;gap:14px;max-width:92vw;font-size:14.5px;line-height:1.35';
    p.innerHTML =
      '<span style="display:inline-flex;width:26px;height:26px;border-radius:50%;' +
        'background:#C9A24B;color:#3A2A46;align-items:center;justify-content:center;' +
        'font-weight:700">&#10003;</span>' +
      '<span style="font-weight:600">' + kopf +
        (spruch ? '<br><span style="font-weight:400;font-size:13px;opacity:.92;' +
                  'max-width:340px;display:inline-block">' + spruch + '</span>' : '') +
      '</span>' +
      '<a href="/cart" id="ys-add-kasse" style="background:#C9A24B;color:#3A2A46;' +
        'text-decoration:none;border-radius:9px;padding:9px 14px;font-weight:700;' +
        'white-space:nowrap">Zur Kasse</a>' +
      '<button type="button" id="ys-add-weiter" style="background:none;' +
        'border:1px solid rgba(246,241,233,.5);color:#F6F1E9;border-radius:9px;' +
        'padding:8px 12px;cursor:pointer;white-space:nowrap">Weiter einkaufen</button>';
    document.body.appendChild(p);

    beacon(spruch, 's');
    var zu = function () { if (p && p.parentNode) p.remove(); };
    var kasse = document.getElementById('ys-add-kasse');
    if (kasse) kasse.addEventListener('click', function () { beacon(spruch, 'k'); });
    var weiter = document.getElementById('ys-add-weiter');
    if (weiter) weiter.addEventListener('click', function () { beacon(spruch, 'w'); zu(); });
    setTimeout(zu, 8000);

    warenkorbZahl();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    var ziel = form.getAttribute('action') || '';
    if (ziel.indexOf('/cart/add') === -1) return;

    ev.preventDefault();
    var knopf = form.querySelector('button[type=submit],button:not([type])');
    var beschriftung = knopf ? knopf.textContent : '';
    if (knopf) { knopf.textContent = 'Wird hinzugefügt …'; knopf.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (knopf) { knopf.textContent = beschriftung; knopf.disabled = false; }
        zeige(form.getAttribute('data-ys-name'));
      })
      .catch(function () { form.submit(); });   // im Zweifel der gewohnte Weg
  }, true);
})();
